export const CRM_FULL_CYCLE_WORKFLOW = {
  key: "crm_full_cycle",
  title: "academy_workflow_title_001",
  subtitle: "academy_workflow_subtitle_001",
  description:
    "academy_workflow_description_001",
  estimatedMinutes: 12,
  moduleIndex: 1,
  moduleCount: 3,
  moduleLabel: "academy_workflow_moduleLabel_001",
  pathLabel: "academy_workflow_pathLabel_001",
  steps: [
    {
      id: "intro",
      title: "academy_workflow_title_002",
      route: "/menu/sales/contacts",
      body: "academy_workflow_body_001",
      checklist: [
        "academy_workflow_checklist_001",
        "academy_workflow_checklist_002",
        "academy_workflow_checklist_003",
      ],
    },
    {
      id: "open-contacts",
      title: "academy_workflow_title_003",
      route: "/menu/sales/contacts",
      autoNavigate: true,
      body: "academy_workflow_body_002",
      variants: [
        {
          id: "contacts-empty",
          whenSelectorExists: '[data-academy="contacts-empty-state"]',
          title: "academy_page_title_015",
          body: "academy_workflow_body_003",
          targetHint: "academy_workflow_targetHint_001",
          interaction: {
            type: "click",
            selector: '[data-academy="contacts-create"]',
            completion: {
              type: "selectorExists",
              selector: '[data-academy="contact-create-modal"]',
            },
            autoAdvance: false,
          },
        },
        {
          id: "contacts-populated",
          whenSelectorExists: '[data-academy="contacts-table"]',
          title: "academy_workflow_title_004",
          body: "academy_workflow_body_004",
          targetHint: "academy_workflow_targetHint_002",
          interaction: {
            type: "click",
            selector: '[data-academy="contacts-create"]',
            completion: {
              type: "selectorExists",
              selector: '[data-academy="contact-create-modal"]',
            },
            autoAdvance: false,
          },
        },
      ],
    },
    {
      id: "create-contact",
      title: "academy_workflow_title_005",
      route: "/menu/sales/contacts",
      body: "academy_workflow_body_005",
      fields: [
        { label: "account_first_name", valueKey: "contactName" },
        { label: "preset_source_email_description", valueKey: "contactEmail" },
        { label: "preset_source_phone", valueKey: "contactPhone" },
      ],
      checklist: [
        "academy_workflow_checklist_004",
        "academy_workflow_checklist_005",
        "academy_workflow_checklist_006",
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="contact-create-modal"]',
        completion: {
          type: "any",
          conditions: [
            { type: "sampleTruthy", key: "contactExists" },
            {
              type: "textExists",
              selector: '[data-academy="contacts-table"]',
              valueKey: "contactName",
            },
          ],
        },
        statusText:
          "academy_workflow_statusText_001",
      },
    },
    {
      id: "open-personal-details",
      title: "academy_workflow_title_006",
      route: "/menu/sales/contacts",
      body: "academy_workflow_body_006",
      targetHint: "academy_workflow_targetHint_003",
      interaction: {
        type: "click",
        selector: '[data-academy="contact-details"]',
        contextSelector: "tr",
        textValueKey: "contactName",
        autoAdvance: false,
        completion: {
          type: "routeMatches",
          pattern: "/menu/sales/contacts/[^/]+/personal-details",
        },
        statusText:
          "academy_workflow_statusText_002",
      },
    },
    {
      id: "open-works",
      title: "academy_workflow_title_007",
      body: "academy_workflow_body_007",
      targetHint: "academy_workflow_targetHint_004",
      interaction: {
        type: "click",
        selector: '[data-academy-tab="works"]',
        autoAdvance: false,
        completion: {
          type: "selectorExists",
          selector: '[data-academy="personal-works"]',
        },
      },
    },
    {
      id: "open-lead-create",
      title: "academy_workflow_title_008",
      body: "academy_workflow_body_008",
      targetHint:
        "academy_workflow_targetHint_005",
      interaction: {
        type: "click",
        selector: '[data-academy="personal-more"]',
        autoAdvance: false,
        completion: {
          type: "selectorExists",
          selector: '[data-academy="lead-create-modal"]',
        },
      },
      variants: [
        {
          id: "lead-menu-open",
          whenSelectorExists: '[data-academy="personal-create-lead"]',
          title: "academy_workflow_title_009",
          targetHint: "academy_workflow_targetHint_006",
          interaction: {
            type: "click",
            selector: '[data-academy="personal-create-lead"]',
            autoAdvance: false,
            completion: {
              type: "selectorExists",
              selector: '[data-academy="lead-create-modal"]',
            },
          },
        },
      ],
    },
    {
      id: "create-lead",
      title: "academy_workflow_title_010",
      body: "academy_workflow_body_009",
      fields: [{ label: "product_custom_field_column_label", valueKey: "leadTitle" }],
      interaction: {
        type: "wait",
        selector: '[data-academy="lead-create-modal"]',
        completion: { type: "sampleTruthy", key: "leadExists" },
        statusText: "academy_workflow_statusText_003",
      },
    },
    {
      id: "open-task-create",
      title: "academy_workflow_title_011",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=works&academy_lead_id={{leadId}}",
      autoNavigate: true,
      body: "academy_workflow_body_010",
      targetHint:
        "academy_workflow_targetHint_007",
      interaction: {
        type: "click",
        selector: '[data-academy="lead-create-task"]',
        autoAdvance: false,
        completion: {
          type: "any",
          conditions: [
            { type: "sampleTruthy", key: "taskExists" },
            {
              type: "selectorExists",
              selector: '[data-academy="task-create-modal"]',
            },
          ],
        },
        statusText:
          "academy_workflow_statusText_004",
      },
    },
    {
      id: "create-task",
      title: "academy_workflow_title_012",
      route: "/menu/sales/tasks",
      body: "academy_workflow_body_011",
      fields: [
        { label: "sales_tasks_title", valueKey: "taskTitle" },
        { label: "dashboard_description", valueKey: "taskDescription" },
        { label: "crm_activities_due_at", valueKey: "taskDueAt" },
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="task-create-modal"]',
        completion: { type: "sampleTruthy", key: "taskExists" },
        statusText:
          "academy_workflow_statusText_005",
      },
    },
    {
      id: "configure-lead",
      title: "academy_workflow_title_013",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=works&academy_lead_id={{leadId}}",
      autoNavigate: true,
      body: "academy_workflow_body_012",
      fields: [
        { label: "academy_workflow_label_001", valueKey: "leadBudget" },
        { label: "academy_workflow_label_002", valueKey: "leadPrepayment" },
      ],
      checklist: [
        "academy_workflow_checklist_007",
        "academy_workflow_checklist_008",
        "academy_workflow_checklist_009",
      ],
      targetHint:
        "academy_workflow_targetHint_008",
      variants: [
        {
          id: "lead-finance-fields-empty",
          whenSelectorExists:
            '[data-academy="lead-finance"][data-academy-finance-ready="false"]',
          title: "academy_workflow_title_014",
          body: "academy_workflow_body_013",
          targetHint: "academy_workflow_targetHint_009",
          interaction: {
            type: "wait",
            selector: '[data-academy="lead-budget"]',
            highlightSelectors: [
              '[data-academy="lead-budget"]',
              '[data-academy="lead-prepayment"]',
            ],
            statusText:
              "academy_workflow_statusText_006",
          },
        },
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="lead-save"]:not(:disabled)',
        completion: {
          type: "all",
          conditions: [
            { type: "sampleTruthy", key: "taskExists" },
            { type: "sampleTruthy", key: "leadConfigured" },
          ],
        },
        statusText:
          "academy_workflow_statusText_007",
      },
    },
    {
      id: "convert-deal",
      title: "academy_workflow_title_015",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=works&academy_lead_id={{leadId}}",
      autoNavigate: true,
      body: "academy_workflow_body_014",
      targetHint: "academy_workflow_targetHint_010",
      interaction: {
        type: "click",
        selector: '[data-academy="lead-convert"]',
        autoAdvance: false,
        completion: { type: "sampleTruthy", key: "dealExists" },
        statusText: "academy_workflow_statusText_008",
      },
    },
    {
      id: "inspect-deal-timeline",
      title: "academy_workflow_title_016",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=works&academy_deal_id={{dealId}}",
      autoNavigate: true,
      body: "academy_workflow_body_015",
      targetHint:
        "academy_workflow_targetHint_011",
      interaction: {
        type: "click",
        selector: '[data-academy="work-timeline-open"]',
        textValueKey: "taskTitle",
        autoAdvance: true,
        statusText:
          "academy_workflow_statusText_009",
      },
    },
    {
      id: "add-deal-photo",
      title: "academy_workflow_title_017",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=works&academy_deal_id={{dealId}}",
      autoNavigate: true,
      body: "academy_workflow_body_016",
      targetHint:
        "academy_workflow_targetHint_012",
      interaction: {
        type: "click",
        selector: '[data-academy="work-add-photo"]:not(:disabled)',
        autoAdvance: false,
        allowManualSkip: true,
        skipLabel: "academy_workflow_skipLabel_001",
        completion: {
          type: "selectorExists",
          selector: '[data-academy="work-photo-item"]',
        },
        statusText:
          "academy_workflow_statusText_010",
      },
    },
    {
      id: "set-pipeline",
      title: "academy_workflow_title_018",
      routeTemplate:
        "/menu/sales/deals?view=kanban&academy=1&deal_id={{dealId}}",
      autoNavigate: true,
      body: "academy_workflow_body_017",
      checklist: ["academy_workflow_checklist_010", "academy_workflow_checklist_011", "academy_workflow_checklist_012"],
      variants: [
        {
          id: "deals-load-error",
          whenSelectorExists: '[data-academy="deals-load-error"]',
          title: "academy_workflow_title_019",
          body: "academy_workflow_body_018",
          targetHint:
            "academy_workflow_targetHint_013",
          interaction: {
            type: "click",
            selector: '[data-academy="deals-refresh"]',
            autoAdvance: false,
            statusText:
              "academy_workflow_statusText_011",
          },
        },
      ],
      interaction: {
        type: "drag",
        selector: '[data-academy="deal-card"]',
        destinationSelector:
          '[data-academy="deal-stage-column"][data-academy-target="true"]',
        dragSourceLabel: "landing_pipeline_new",
        dragTargetLabel: "landing_pipeline_qualified",
        dragGuideLabel: "academy_workflow_dragGuideLabel_001",
        highlightSelectors: [
          '[data-academy="deal-card"]',
          '[data-academy="deal-stage-column"][data-academy-target="true"]',
        ],
        textValueKey: "leadTitle",
        completion: {
          type: "any",
          conditions: [
            {
              type: "selectorExists",
              selector:
                '[data-academy="deal-stage-column"][data-academy-stage-code="qualified"] [data-academy="deal-card"]',
            },
            { type: "sampleTruthy", key: "dealWon" },
          ],
        },
        statusText:
          "academy_workflow_statusText_012",
      },
    },
    {
      id: "create-activity",
      title: "academy_workflow_title_020",
      routeTemplate:
        "/menu/sales/activities?create=1&academy=1&contact_ui_id={{contactUiId}}&deal_ui_id={{dealUiId}}&activity_title={{activityTitle}}&activity_description={{activityDescription}}",
      autoNavigate: true,
      body: "academy_workflow_body_019",
      fields: [
        { label: "product_custom_field_column_type", value: "call" },
        { label: "crm_activities_action", valueKey: "activityTitle" },
        { label: "notes", valueKey: "activityDescription" },
        { label: "crm_activities_status", value: "Завершено" },
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="activity-create-modal"]',
        completion: { type: "sampleTruthy", key: "activityDone" },
        statusText:
          "academy_workflow_statusText_013",
      },
    },
    {
      id: "check-timeline",
      title: "academy_workflow_title_021",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=activities",
      autoNavigate: true,
      body: "academy_workflow_body_020",
      fields: [{ label: "academy_workflow_label_003", valueKey: "activityTitle" }],
      checklist: [
        "academy_workflow_checklist_013",
        "academy_workflow_checklist_014",
        "academy_workflow_checklist_015",
      ],
      targetHint:
        "academy_workflow_targetHint_014",
      variants: [
        {
          id: "timeline-activity-not-loaded",
          whenSelectorMissing:
            '[data-academy="timeline-event-open"][data-academy-event-kind="activity"]',
          title: "academy_workflow_title_022",
          body: "academy_workflow_body_021",
          targetHint:
            "academy_workflow_targetHint_015",
          interaction: {
            type: "click",
            selector: '[data-academy="timeline-refresh"]',
            autoAdvance: false,
            statusText:
              "academy_workflow_statusText_014",
          },
        },
      ],
      interaction: {
        type: "click",
        selector:
          '[data-academy="timeline-event-open"][data-academy-event-kind="activity"]',
        textValueKey: "activityTitle",
        autoAdvance: true,
        statusText:
          "academy_workflow_statusText_015",
      },
    },
    {
      id: "win-deal",
      title: "academy_workflow_title_023",
      routeTemplate:
        "/menu/sales/deals?view=kanban&academy=1&deal_id={{dealId}}",
      autoNavigate: true,
      body: "academy_workflow_body_022",
      targetHint:
        "academy_workflow_targetHint_016",
      interaction: {
        type: "drag",
        selector: '[data-academy="deal-card"]',
        destinationSelector:
          '[data-academy="deal-stage-column"][data-academy-target="true"]',
        dragSourceFallbackLabel: "academy_workflow_dragSourceFallbackLabel_001",
        dragTargetLabel: "lead_status_won",
        dragGuideLabel: "academy_workflow_dragGuideLabel_002",
        highlightSelectors: [
          '[data-academy="deal-card"]',
          '[data-academy="deal-stage-column"][data-academy-target="true"]',
        ],
        textValueKey: "leadTitle",
        autoAdvance: false,
        completion: { type: "sampleTruthy", key: "dealWon" },
        statusText:
          "academy_workflow_statusText_016",
      },
    },
    {
      id: "complete",
      title: "academy_workflow_title_024",
      body: "academy_workflow_body_023",
      checklist: [
        "academy_workflow_checklist_016",
        "academy_workflow_checklist_017",
        "academy_workflow_checklist_018",
        "academy_workflow_checklist_019",
        "academy_workflow_checklist_020",
        "academy_workflow_checklist_021",
      ],
    },
  ],
};

function toDateTimeLocal(date) {
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function createWorkflowSample() {
  const suffix = String(Date.now()).slice(-5);
  const marker = `ACADEMY-${suffix}`;
  const sessionId = `crm-full-cycle-${Date.now()}-${suffix}`;
  const taskDue = new Date();
  taskDue.setDate(taskDue.getDate() + 1);
  taskDue.setHours(12, 0, 0, 0);

  return {
    suffix,
    marker,
    sessionId,
    contactName: `Academy Client ${suffix} [${marker}]`,
    contactEmail: `academy.client.${suffix}@example.com`,
    contactPhone: `+372555${suffix}`,
    leadTitle: `CRM test order ${suffix} [${marker}]`,
    leadBudget: "500",
    leadPrepayment: "100",
    taskTitle: `Первичный созвон ${suffix} [${marker}]`,
    taskDescription:
      "academy_workflow_taskDescription_001",
    taskDueAt: toDateTimeLocal(taskDue),
    activityTitle: `Созвон по заказу ${suffix} [${marker}]`,
    activityDescription:
      "academy_workflow_activityDescription_001",
  };
}

export const TASK_PLANNING_WORKFLOW = {
  key: "task_planning",
  title: "academy_workflow_title_025",
  subtitle: "academy_workflow_subtitle_002",
  description:
    "academy_workflow_description_002",
  estimatedMinutes: 6,
  moduleIndex: 2,
  moduleCount: 3,
  moduleLabel: "academy_workflow_moduleLabel_002",
  pathLabel:
    "academy_workflow_pathLabel_002",
  introActionLabel: "academy_workflow_introActionLabel_001",
  introFootnote:
    "academy_workflow_introFootnote_001",
  steps: [
    {
      id: "continue-with-contact",
      title: "academy_workflow_title_026",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=works&academy_task_planning=1",
      autoNavigate: true,
      body: "academy_workflow_body_024",
      checklist: [
        "academy_workflow_checklist_022",
        "academy_workflow_checklist_023",
        "academy_workflow_checklist_024",
      ],
    },
    {
      id: "create-future-task",
      title: "academy_workflow_title_027",
      route: "/menu/sales/tasks",
      body: "academy_workflow_body_025",
      fields: [
        { label: "sales_tasks_title", valueKey: "taskTitle" },
        { label: "dashboard_description", valueKey: "taskDescription" },
        { label: "academy_workflow_label_004", valueKey: "taskDueAt" },
      ],
      checklist: [
        "academy_workflow_checklist_025",
        "academy_workflow_checklist_026",
        "academy_workflow_checklist_027",
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="task-create-modal"]',
        highlightSelectors: [
          '[data-academy="task-title"]',
          '[data-academy="task-description"]',
          '[data-academy="task-due-at"]',
          '[data-academy="task-create-submit"]',
        ],
        completion: { type: "sampleTruthy", key: "taskExists" },
        statusText:
          "academy_workflow_statusText_017",
      },
    },
    {
      id: "understand-activities",
      title: "academy_workflow_title_028",
      routeTemplate:
        "/menu/sales/activities?academy_task_planning=1&academy_task_id={{taskId}}",
      autoNavigate: true,
      body: "academy_workflow_body_026",
      checklist: [
        "academy_workflow_checklist_028",
        "academy_workflow_checklist_029",
        "academy_workflow_checklist_030",
        "academy_workflow_checklist_031",
      ],
    },
    {
      id: "move-task-today",
      title: "academy_workflow_title_029",
      routeTemplate:
        "/menu/sales/activities?academy_task_planning=1&academy_task_id={{taskId}}",
      autoNavigate: true,
      body: "academy_workflow_body_027",
      targetHint: "academy_workflow_targetHint_017",
      interaction: {
        type: "drag",
        selector: '[data-academy="activities-task-card"]',
        destinationSelector:
          '[data-academy="activities-column"][data-academy-column="today"]',
        dragEntityLabel: "task",
        dragSourceLabel: "crm_activities_column_upcoming",
        dragTargetLabel: "crm_activities_column_today",
        dragGuideLabel: "academy_workflow_title_029",
        highlightSelectors: [
          '[data-academy="activities-task-card"]',
          '[data-academy="activities-column"][data-academy-column="today"]',
        ],
        textValueKey: "taskTitle",
        autoAdvance: false,
        completion: {
          type: "selectorExists",
          selector: '[data-academy="activities-planning-modal"]',
        },
        statusText:
          "academy_workflow_statusText_018",
      },
    },
    {
      id: "choose-free-time",
      title: "academy_workflow_title_030",
      routeTemplate:
        "/menu/sales/activities?academy_task_planning=1&academy_task_id={{taskId}}",
      body: "academy_workflow_body_028",
      checklist: [
        "academy_workflow_checklist_032",
        "academy_workflow_checklist_033",
        "academy_workflow_checklist_034",
        "academy_workflow_checklist_035",
      ],
      targetHint: "academy_workflow_targetHint_018",
      interaction: {
        type: "wait",
        selector: '[data-academy="activities-planning-modal"]',
        highlightSelectors: [
          '[data-academy="activities-planning-date"]',
          '[data-academy="activities-planning-time"]',
          '[data-academy="activities-find-free"]',
          '[data-academy="activities-free-slot"]:not(:disabled)',
          '[data-academy="activities-planning-save"]',
        ],
        completion: { type: "sampleTruthy", key: "taskMovedToday" },
        statusText:
          "academy_workflow_statusText_019",
      },
    },
    {
      id: "simulate-overdue",
      title: "academy_workflow_title_031",
      routeTemplate:
        "/menu/sales/activities?academy_task_planning=1&academy_task_id={{taskId}}",
      body: "academy_workflow_body_029",
      checklist: [
        "academy_workflow_checklist_036",
        "academy_workflow_checklist_037",
        "academy_workflow_checklist_038",
      ],
      interaction: {
        type: "action",
        actionKey: "markTaskOverdue",
        actionLabel: "academy_workflow_actionLabel_001",
        completion: { type: "sampleTruthy", key: "taskOverdue" },
        statusText:
          "academy_workflow_statusText_020",
      },
    },
    {
      id: "review-overdue",
      title: "academy_workflow_title_032",
      routeTemplate:
        "/menu/sales/tasks?academy_overdue=1&academy_task_id={{taskId}}",
      autoNavigate: true,
      body: "academy_workflow_body_030",
      targetHint: "academy_workflow_targetHint_019",
      interaction: {
        type: "click",
        selector: '[data-academy="task-actions-trigger"]',
        contextSelector: '[data-academy="task-row"]',
        textValueKey: "taskTitle",
        highlightSelectors: [
          '[data-academy="task-overdue-guide"]',
          '[data-academy="task-tab-overdue"]',
          '[data-academy="task-row"][data-academy-training-task="true"]',
          '[data-academy="task-due"][data-academy-training-task="true"]',
          '[data-academy="task-actions-trigger"][data-academy-training-task="true"]',
        ],
        autoAdvance: false,
        completion: {
          type: "selectorExists",
          selector: '[data-academy="task-actions-menu"]',
        },
        statusText:
          "academy_workflow_statusText_021",
      },
    },
    {
      id: "complete-overdue",
      title: "academy_workflow_title_033",
      routeTemplate:
        "/menu/sales/tasks?academy_overdue=1&academy_task_id={{taskId}}",
      body: "academy_workflow_body_031",
      targetHint: "academy_workflow_targetHint_020",
      interaction: {
        type: "click",
        selector:
          '[data-academy="task-mark-done"][data-academy-training-task="true"]',
        highlightSelectors: [
          '[data-academy="task-mark-done"][data-academy-training-task="true"]',
        ],
        autoAdvance: false,
        completion: { type: "sampleTruthy", key: "taskDone" },
        statusText:
          "academy_workflow_statusText_022",
      },
    },
    {
      id: "check-task-timeline",
      title: "academy_workflow_title_034",
      routeTemplate:
        "/menu/sales/contacts/{{contactId}}/personal-details?academy_tab=activities",
      autoNavigate: true,
      body: "academy_workflow_body_032",
      targetHint: "academy_workflow_targetHint_021",
      interaction: {
        type: "click",
        selector: '[data-academy="timeline-event-open"]',
        contextSelector: '[data-academy="timeline-event"]',
        textValueKey: "taskTitle",
        autoAdvance: true,
        statusText: "academy_workflow_statusText_023",
      },
    },
    {
      id: "complete",
      title: "academy_workflow_title_035",
      route: "/menu/academy",
      autoNavigate: true,
      body: "academy_workflow_body_033",
      checklist: [
        "academy_workflow_checklist_039",
        "academy_workflow_checklist_040",
        "academy_workflow_checklist_041",
        "academy_workflow_checklist_042",
        "academy_workflow_checklist_043",
        "academy_workflow_checklist_044",
        "academy_workflow_checklist_045",
      ],
    },
  ],
};

export function createTaskPlanningSample(previousSample = null) {
  const now = new Date();
  const suffix = String(now.getTime()).slice(-6);
  const previousMarker = String(
    previousSample?.cleanupMarker || previousSample?.marker || "",
  ).trim();
  const marker = previousMarker
    ? previousMarker + "-TASKS"
    : "TASK-ACADEMY-" + suffix;
  const future = new Date(now);
  future.setDate(future.getDate() + 2);
  future.setHours(10 + (Number(suffix.slice(-1)) % 6), 0, 0, 0);

  return {
    sessionId: previousSample?.sessionId || "task-planning-" + now.getTime(),
    marker,
    cleanupMarker:
      previousSample?.cleanupMarker || previousSample?.marker || marker,
    continuedFromFullCycle: Boolean(previousSample?.contactEmail),
    contactName:
      previousSample?.contactName ||
      "Academy Task Client " + suffix + " [" + marker + "]",
    contactEmail:
      previousSample?.contactEmail || "academy.task." + suffix + "@example.com",
    contactPhone: previousSample?.contactPhone || null,
    contactId: previousSample?.contactId || null,
    contactUiId: previousSample?.contactUiId || null,
    previousLeadId: previousSample?.leadId || null,
    previousDealId: previousSample?.dealId || null,
    leadTitle: "Task planning Lead " + suffix + " [" + marker + "]",
    taskTitle: "Проверить срок клиента " + suffix + " [" + marker + "]",
    taskDescription:
      "academy_workflow_taskDescription_002",
    taskDueAt: toDateTimeLocal(future),
  };
}

export const TABLES_WORKFLOW = {
  key: "tables_workflow",
  title: "academy_workflow_title_036",
  subtitle: "academy_workflow_subtitle_003",
  description:
    "academy_workflow_description_003",
  estimatedMinutes: 5,
  moduleIndex: 3,
  moduleCount: 3,
  moduleLabel: "academy_workflow_moduleLabel_003",
  pathLabel: "academy_workflow_pathLabel_003",
  introActionLabel: "academy_workflow_introActionLabel_002",
  introFootnote:
    "academy_workflow_introFootnote_002",
  steps: [
    {
      id: "tables-intro",
      title: "academy_workflow_title_037",
      routeTemplate:
        "/menu/sales/contacts?academy_tables=1&academy_contact={{contactName}}&academy_lead_title={{leadTitle}}&academy_lead_description={{leadDescription}}&academy_task_title={{taskTitle}}&academy_task_description={{taskDescription}}&academy_task_due={{taskDueAt}}",
      autoNavigate: true,
      body: "academy_workflow_body_034",
      checklist: [
        "academy_workflow_checklist_046",
        "academy_workflow_checklist_047",
        "academy_workflow_checklist_048",
        "academy_workflow_checklist_049",
      ],
    },
    {
      id: "contacts-table-map",
      title: "academy_workflow_title_038",
      routeTemplate:
        "/menu/sales/contacts?academy_tables=1&academy_contact={{contactName}}&academy_lead_title={{leadTitle}}&academy_lead_description={{leadDescription}}&academy_task_title={{taskTitle}}&academy_task_description={{taskDescription}}&academy_task_due={{taskDueAt}}",
      autoNavigate: true,
      body: "academy_workflow_body_035",
      interaction: {
        type: "wait",
        selector: '[data-academy="contacts-search"]',
        highlightSelectors: [
          '[data-academy="contacts-create"]',
          '[data-academy="contacts-search"]',
          '[data-academy="contacts-table"]',
        ],
        allowManualSkip: true,
        skipLabel: "academy_workflow_skipLabel_002",
        statusText:
          "academy_workflow_statusText_024",
      },
    },
    {
      id: "create-lead-from-contact-row",
      title: "academy_workflow_title_039",
      routeTemplate:
        "/menu/sales/contacts?academy_tables=1&academy_contact={{contactName}}&academy_lead_title={{leadTitle}}&academy_lead_description={{leadDescription}}&academy_task_title={{taskTitle}}&academy_task_description={{taskDescription}}&academy_task_due={{taskDueAt}}",
      autoNavigate: true,
      body: "academy_workflow_body_036",
      targetHint: "academy_workflow_targetHint_022",
      interaction: {
        type: "click",
        selector: '[data-academy="contact-create-lead"]',
        contextSelector: "tr",
        textValueKey: "contactName",
        autoAdvance: false,
        completion: {
          type: "selectorExists",
          selector: '[data-academy="contact-lead-modal"]',
        },
        statusText: "academy_workflow_statusText_025",
      },
    },
    {
      id: "save-table-lead",
      title: "academy_workflow_title_040",
      body: "academy_workflow_body_037",
      fields: [
        { label: "product_custom_field_column_label", valueKey: "leadTitle" },
        { label: "dashboard_description", valueKey: "leadDescription" },
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="contact-lead-modal"]',
        highlightSelectors: [
          '[data-academy="contact-lead-title"]',
          '[data-academy="contact-lead-description"]',
          '[data-academy="contact-lead-submit"]',
        ],
        completion: { type: "sampleTruthy", key: "leadExists" },
        statusText:
          "academy_workflow_statusText_026",
      },
    },
    {
      id: "understand-lead-groups",
      title: "academy_workflow_title_041",
      routeTemplate:
        "/menu/sales/leads?contact_id={{contactId}}&lead_id={{leadId}}&lead_ui_id={{leadUiId}}&academy_tables=1&academy_task_title={{taskTitle}}&academy_task_description={{taskDescription}}&academy_task_due={{taskDueAt}}",
      autoNavigate: true,
      body: "academy_workflow_body_038",
      interaction: {
        type: "wait",
        selector: '[data-academy="leads-tabs"]',
        highlightSelectors: [
          '[data-academy="leads-tabs"]',
          '[data-academy="leads-table"]',
        ],
        allowManualSkip: true,
        skipLabel: "academy_workflow_skipLabel_003",
        statusText:
          "academy_workflow_statusText_027",
      },
    },
    {
      id: "open-lead-table-actions",
      title: "academy_workflow_title_042",
      body: "academy_workflow_body_039",
      targetHint: "academy_workflow_targetHint_023",
      interaction: {
        type: "click",
        selector: '[data-academy="lead-actions-trigger"]',
        contextSelector: '[data-academy="lead-row"]',
        textValueKey: "leadTitle",
        autoAdvance: false,
        completion: {
          type: "selectorExists",
          selector: '[data-academy="lead-actions-menu"]',
        },
        statusText: "academy_workflow_statusText_028",
      },
    },
    {
      id: "create-task-from-lead-row",
      title: "academy_workflow_title_012",
      body: "academy_workflow_body_040",
      targetHint: "academy_workflow_targetHint_024",
      interaction: {
        type: "click",
        selector: '[data-academy="lead-create-task"]',
        highlightSelectors: ['[data-academy="lead-create-task"]'],
        autoAdvance: true,
        statusText: "academy_workflow_statusText_029",
      },
    },
    {
      id: "save-table-task",
      title: "academy_workflow_title_043",
      route: "/menu/sales/tasks",
      body: "academy_workflow_body_041",
      fields: [
        { label: "sales_tasks_title", valueKey: "taskTitle" },
        { label: "dashboard_description", valueKey: "taskDescription" },
        { label: "crm_activities_due_at", valueKey: "taskDueAt" },
      ],
      interaction: {
        type: "wait",
        selector: '[data-academy="task-create-modal"]',
        highlightSelectors: [
          '[data-academy="task-title"]',
          '[data-academy="task-description"]',
          '[data-academy="task-due-at"]',
          '[data-academy="task-create-submit"]',
        ],
        completion: { type: "sampleTruthy", key: "taskExists" },
        statusText:
          "academy_workflow_statusText_030",
      },
    },
    {
      id: "tasks-table-map",
      title: "academy_workflow_title_044",
      routeTemplate:
        "/menu/sales/tasks?academy_table_task=1&academy_task_id={{taskId}}",
      autoNavigate: true,
      body: "academy_workflow_body_042",
      interaction: {
        type: "wait",
        selector: '[data-academy="tasks-tabs"]',
        highlightSelectors: [
          '[data-academy="tasks-tabs"]',
          '[data-academy="tasks-table"]',
        ],
        allowManualSkip: true,
        skipLabel: "academy_workflow_skipLabel_004",
        statusText:
          "academy_workflow_statusText_031",
      },
    },
    {
      id: "tables-complete",
      title: "academy_workflow_title_045",
      route: "/menu/academy",
      autoNavigate: true,
      body: "academy_workflow_body_043",
      checklist: [
        "academy_workflow_checklist_050",
        "academy_workflow_checklist_051",
        "academy_workflow_checklist_052",
        "academy_workflow_checklist_053",
        "academy_workflow_checklist_054",
      ],
    },
  ],
};

export function createTablesWorkflowSample(previousSample = null) {
  const now = new Date();
  const suffix = String(now.getTime()).slice(-6);
  const cleanupMarker = String(
    previousSample?.cleanupMarker || previousSample?.marker || "",
  ).trim();
  const marker = cleanupMarker
    ? cleanupMarker + "-TABLES"
    : "TABLES-ACADEMY-" + suffix;
  const future = new Date(now);
  future.setDate(future.getDate() + 1);
  future.setHours(11 + (Number(suffix.slice(-1)) % 5), 0, 0, 0);

  return {
    sessionId: previousSample?.sessionId || "tables-workflow-" + now.getTime(),
    marker,
    cleanupMarker: cleanupMarker || marker,
    contactName: previousSample?.contactName || "",
    contactEmail: previousSample?.contactEmail || "",
    contactId: previousSample?.contactId || null,
    contactUiId: previousSample?.contactUiId || null,
    contactExists: Boolean(previousSample?.contactId),
    leadTitle: "Table workflow Lead " + suffix + " [" + marker + "]",
    leadDescription:
      "Учебный Lead, созданный из таблицы Contacts. " + marker,
    taskTitle: "Следующее действие " + suffix + " [" + marker + "]",
    taskDescription:
      "academy_workflow_taskDescription_003",
    taskDueAt: toDateTimeLocal(future),
  };
}
